/*
 * offTimeBalances.accruedHours / carriedOverHours / usedHours are named "hours"
 * but hold SECONDS (see server/constants/pto.js). Spendable balance is
 * accrued + carriedOver - used, and every screen shows it through getTimeString,
 * which takes MINUTES.
 *
 * Every operand is coerced: accruedHours is a DECIMAL column and mysql2 hands
 * it back as a string, so the `accrued + carriedOver - used` expression this
 * replaces was doing string concatenation rather than addition — harmless while
 * carriedOverHours was 0, and off by several orders of magnitude the moment a
 * member had any carryover.
 */
// eslint-disable-next-line import/prefer-default-export
export const balanceMinutes = (balance) => {
  if (!balance) return 0;

  const seconds = Number(balance.accruedHours || 0)
    + Number(balance.carriedOverHours || 0)
    - Number(balance.usedHours || 0);

  return seconds / 60;
};
